import { render, staticRenderFns } from "./AddProcessorDefinitionToTalkgroup.vue?vue&type=template&id=345f9867&scoped=true&"
import script from "./AddProcessorDefinitionToTalkgroup.vue?vue&type=script&lang=js&"
export * from "./AddProcessorDefinitionToTalkgroup.vue?vue&type=script&lang=js&"
import style0 from "./AddProcessorDefinitionToTalkgroup.vue?vue&type=style&index=0&id=345f9867&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f9867",
  null
  
)

export default component.exports